import React from "react";
import styles from "./categories.module.css";
import { Heading, Paragraph } from "../TextComponents/TextComponents";
import { Col, Container, Row } from "react-bootstrap";
import { LightBgButton } from "../Buttons/LightBgButton";
const Categories = ({handleShow}) => {
  const cards = [
    {
      title: "Fintech",
      description: "Payments, lending, and investments.",
      Image: "/images/Homepage/icon/banknotes.png",
      Alt : "Fintech solutions - Buildshell"
    },
    {
      title: "Healthtech",
      description: "Telemedicine, health analytics, and devices.",
      Image: "/images/Homepage/icon/heart.png",
      Alt : "Healthtech solutions - Buildshell"
    },
    {
      title: "Edtech",
      description: "Online learning platforms and tools.",
      Image: "/images/Homepage/icon/cube.png",
      Alt : "Edtech solutions - Buildshell"
    },
    {
      title: "E-commerce",
      description: "Marketplaces and digital payment solutions.",
      Image: "/images/Homepage/icon/delivery.png",
      Alt : "E-commerce solutions - Buildshell"
    },
    {
      title: "Artificial Intelligence (AI)",
      description: "Machine learning, natural language processing",
      Image: "/images/Homepage/icon/banknotes.png",
      Alt : "Artificial Intelligence (AI) solutions - Buildshell"
    },
    {
      title: "Cybersecurity",
      description:
        "Cyber threats, including malware, phishing, and ransomware.",
      Image: "/images/Homepage/icon/shield.png",
      Alt : "Cybersecurity solutions - Buildshell"
    },
  ];

  return (
    <React.Fragment>
      <Container>
        <div className={styles.main_section} id="vertical">
          <LightBgButton label={'Verticals'} bg="#CCD7FF" color="var(--primary-color)" />
          <Heading>
          Serving a Wide Range of <br /> Domains we serve
          </Heading>
          <Paragraph color="#2A2A2A">
          We specialize in building powerful, industry-specific solutions:
          </Paragraph>

          <Row>
            {cards.map((item, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={4}>
                <div className={styles.card}>
                  <img src={item.Image} alt={item.Alt} />
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </Col>
            ))}
          </Row>
          <h6>
            Didn’t find your categories ? No worries Just{" "}
            <span onClick={handleShow} style={{ color: "#2E68FD", cursor: "pointer" }}>
              connect with us
            </span>{" "}
            we will resolve your query{" "}
          </h6>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default Categories;
